import i18next from 'i18next';
import { isSmDown } from '~/lib/responsive';
import type { DesignFiltersState, useDesignFiltersParams } from './';

const INITIAL_PUBLISHED = [
  { label: i18next.t('common.boolean.true'), selected: false, value: true },
  { label: i18next.t('common.boolean.false'), selected: false, value: false },
];

export const allUnselectedState: DesignFiltersState = {
  filters: {
    tags: { open: false, items: [] },
    published: { open: false, items: INITIAL_PUBLISHED },
  },
  panel: { open: false },
};

export const getDesignFiltersState = (params: ReturnType<typeof useDesignFiltersParams>) => {
  const isDesignSmDown = isSmDown();
  return {
    filters: {
      tags: { open: false, items: [] },
      published: {
        open: params.published.length > 0,
        items: INITIAL_PUBLISHED.map((x) => ({
          ...x,
          selected: params.published.includes(x.value),
        })),
      },
    },
    panel: { open: !isDesignSmDown && Object.values(params).flat().length > 0 },
  };
};
